import styled, { css } from 'styled-components';
import { Row } from 'components/shared/Layout';
import { colours } from 'themes/default';

export const VerticalLine = styled.div`
  border-right: 1px solid black;
  padding: 0 16px;
`;

export const StyledExtrasContainer = styled(Row)`
  background: white;
  box-shadow: 0px 0px 30px ${colours.Greyscale.MistGrey};
  padding: 24px 16px;
`;

export const StyledDisplayFeesBreakdown = styled.div`
  margin-left: 10px;
  font-style: italic;
`;

export const StyledHotelDetailsContainer = styled(Row)`
  background: ${colours.Greyscale.MistGrey};
  box-shadow: 0px 0px 30px ${colours.Greyscale.MistGrey};
  padding: 24px 16px;
  margin-bottom: 40px;
`;

export const StyledLegContainer = styled.div`
  margin-bottom: 40px;
`;
export const StyledJourneyInfoContainer = styled.div`
  margin-bottom: 24px;
`;

export const StyledPrice = styled.div`
  background: aliceblue;
  padding: 8px 16px;
  text-align: right;
`;

export const StyledHr = styled.hr`
  width: 100%;
`;

export const LastColumn = styled.div`
  padding: 0 16px;
`;

export const HotelDetailsHintArrow = styled.span`
  ${(props) =>
    props.isExpanded
      ? css`
          padding-top: 10px;
          transform: rotate(-90deg);
        `
      : css`
          padding-bottom: 10px;
          transform: rotate(90deg);
        `}
`;

export const ManageExtrasButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ApiUsedMessage = styled.span`
  color: ${colours.Messaging.ErrorRed};
  margin-bottom: 2rem;
  font-weight: bold;
`;

export const StyledName = styled.span`
  font-weight: bold;
`;
